<template>
  <div>
    <div>
      <el-tag type="primary">Testing Panel {{$route.params.division}} Division</el-tag>
      <span v-if="!isUserCustomer && !isUserReseller">
        <small class="ml-2 text-info">Search By Vendor</small> <el-switch @change="searchMethod"  v-model="searchByVendorOption"></el-switch>
      </span>
      <span class="float-right mr-3 pt-2" style="font-family: Consolas;font-size: 9pt" v-if="isUserRoot">
        PBX: {{$store.state['user-state'].ourVOSIP}}
      </span>
    </div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchByVendorOption: $store.state['voip-testing-panel-state'].searchByVendorOption,
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserRoot: $store.getters['user-state/isUserRoot'],
    }
  },
  methods: {
   searchMethod () {
     $store.state['voip-testing-panel-state'].searchByVendorOption = this.searchByVendorOption
   }
  }
}
</script>
